import React, { useMemo } from "react";
import * as S from "./CmpTextAreaInput.style";
import { useTranslation } from "react-i18next";
import { PopUpPayload } from "../genericTemplate/GenericTemplate.style";
import Popup from "reactjs-popup";

// pipes
import * as P from "../../../../../../../utils/pipes";

// Components
import SelectorForm from "../selectorForm";
import FlorenzTextArea from "../../../../../../florenzComponents/florenzTextArea";

function CmpTextAreaInput({
  item,
  insertfunction,
  customFormChangeItem,
  typeView
}) {  
  const { i18n: { language } } = useTranslation("global");

  const changeOptionItem = (value) => {
    const userToCustomFormField = {
      customFormFieldParentId: item?.customFormFieldParentId,
      customFormFieldId: item.id,
      value: value.toString(),
      key: value.toString()
    }
    insertfunction(userToCustomFormField)
  }

  const displayValue = useMemo(() => {
    return customFormChangeItem && customFormChangeItem.value.toString();
  }, [customFormChangeItem]);

  const handleKeyUp = (e, msg) => {
    if(e.target.scrollHeight !== 100) {
      e.target.style.height = 'inherit';
      e.target.style.height = `${e.target.scrollHeight}px`; 
    }
    if(msg === ""){
      e.target.style.height = '100px';
    }
  }

  return (
    <S.CmpTextAreaInput>
      <div className="selection-container">
        <div className="title">
          <div className="title__text">
            {item.fieldName && P.dataTranslation(item.fieldName, language)}
          </div>
          {
            displayValue
            ? <i className="title__icon icon zaia-i-check-1"></i>
            : <div className="title__required error">{!item.optional && "*"}</div>
          }
          <Popup
            trigger={
              <i className="title__icon-payload icon zaia-alert"></i>
            }
            on={['hover', 'focus']}
            closeOnDocumentClick
            keepTooltipInside
            position={['right center']}
            nested
          >
            <PopUpPayload>
              <p>
              {P.dataTranslation(item.descript, language)}
              </p>
            </PopUpPayload>
          </Popup>
        </div>
        <div className="input-container">
          <FlorenzTextArea
            value={displayValue}
            getText={changeOptionItem}
            disabled={typeView === 'view'}
            onKeyUp={(e) => handleKeyUp(e, displayValue)}
          />
        </div>
      </div>
    </S.CmpTextAreaInput>
  );
}

export default CmpTextAreaInput;
